export default "__VITE_ASSET__402c3c3c__"